function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import * as Utility from "../commons/Utility";
import * as UserApi from "../ajax/UserApi";
import * as ProfileApi from "../ajax/ProfileApi";
import Croppie from 'croppie';
import 'croppie/croppie.css';
import IntlMessage from '../commons/Intl';
import { Action, Thumbnail, Errors, Description, Placeholder } from '../commons/IntlMessages';
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language);
var maxFileSize = 5 * 1024 * 1024; // ユーザーサムネイル変更モーダル

/**
 * モード
 */

export var Mode;

(function (Mode) {
  /**
   * なし
   */
  Mode[Mode["None"] = 0] = "None";
  /**
   * 更新
   */

  Mode[Mode["Modify"] = 2] = "Modify";
  /**
   * プロフィール
   */

  Mode[Mode["Profile"] = 3] = "Profile";
})(Mode || (Mode = {}));
/**
 * メインコンポーネント
 */


var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);
    /* Blob to file
       https://stackoverflow.com/questions/27159179/how-to-convert-blob-to-file-in-javascript
    */

    _this.blobToFile = function (theBlob, fileName) {
      var b = theBlob; //A Blob() is almost a File() - it's just missing the two properties below which we will add

      b.lastModifiedDate = Date.now();
      b.name = fileName; //Cast to a File() type

      var file = b;
      return file;
    };

    switch (props.mode) {
      case Mode.Modify:
        _this.state = {
          Modal: null,
          UserId: _this.props.userId,
          ThumbnailFileName: _this.props.thumbnailFileName,
          ErrorMessages: [],
          isFileSelected: false
        };
        break;

      case Mode.Profile:
        _this.state = {
          Modal: null,
          UserId: _this.props.userId,
          ThumbnailFileName: _this.props.thumbnailFileName,
          ErrorMessages: [],
          isFileSelected: false
        };
        break;

      default:
        throw Error();
    }

    _this.GetThumbnailUrl();

    return _this;
  }

  _createClass(MainComponent, [{
    key: "GetThumbnailUrl",
    value: function GetThumbnailUrl() {
      if (!this.props.userId || !this.props.thumbnailFileName) {
        return;
      }

      if (this.props.mode == Mode.Profile) {
        ProfileApi.GetThumbnail(this.state.UserId, this.state.ThumbnailFileName, function (blob) {
          $("#userthumbnailmodaliconframe").css("background-image", 'url(' + window.URL.createObjectURL(blob) + ')');
          $("#thumbnailframe").css("background-image", 'url(' + window.URL.createObjectURL(blob) + ')');
        });
      } else {
        UserApi.GetThumbnail(this.state.UserId, this.state.ThumbnailFileName, function (blob) {
          $("#userthumbnailmodaliconframe").css("background-image", 'url(' + window.URL.createObjectURL(blob) + ')');
          $("#thumbnailframe").css("background-image", 'url(' + window.URL.createObjectURL(blob) + ')');
        });
      }
    }
    /**
     * 「アップロード」ボタン押下時の処理を行います。
     */

  }, {
    key: "onUploadClick",
    value: function onUploadClick() {
      $("#Thumbnail").click();
    }
    /**
     * ファイル選択時の処理を行います。
     */

  }, {
    key: "onChangeThumbnail",
    value: function onChangeThumbnail(e) {
      if (this.state.Modal == null || !this.props.userId) {
        throw Error();
      }

      this.state.ErrorMessages.length = 0;
      var form = $("#MainForm");
      $.validator.unobtrusive.parse(form);
      form.validate();

      if (form.valid()) {
        if (!this.props.userId || e.target == null) {
          throw Error();
        }

        if (e.target.files == null) {
          return;
        }

        var file = e.target.files.item(0);

        if (file == null) {
          return;
        }

        var fileExtension = Utility.getFileExtension(file.name);

        if (fileExtension == null || !(fileExtension == "jpg" || fileExtension == "jpeg" || fileExtension == "png")) {
          this.state.ErrorMessages.push(intl.format(Errors.InputWrongExtention, {
            extention: ".jpg, .jpeg, .png"
          }));
        }

        if (file.size > maxFileSize) {
          this.state.ErrorMessages.push(intl.format(Errors.InputWrongFileSize, {
            size: (maxFileSize / 1024 / 1024).toString() + "MB"
          }));
        }

        if (this.state.ErrorMessages.length != 0) {
          this.setState({
            ErrorMessages: this.state.ErrorMessages
          });
          return;
        }

        this.onFileSelect(file);
      }
    } //クロッププレビューを更新(アップロードはまだしない)

  }, {
    key: "onFileSelect",
    value: function onFileSelect(file) {
      this.setState({
        isFileSelected: true
      });
      this.setState({
        ThumbnailFileName: file.name
      });
      $("#userthumbnailmodaliconframe").css("background-image", 'url(' + window.URL.createObjectURL(file) + ')');
      var thumbnailFrame = $("#thumbnailframe");
      thumbnailFrame.css("background-image", 'none');

      if (this.croppie == null) {
        var croppieOptions = new ( /*#__PURE__*/function () {
          function _class() {
            _classCallCheck(this, _class);

            this.boundary = {
              width: 150,
              height: 150
            };
            this.enableExif = false;
            this.enableOrientation = false;
            this.enableZoom = true;
            this.enforceBoundary = true;
            this.mouseWheelZoom = true;
            this.showZoomer = true;
            this.viewport = {
              width: 100,
              height: 100,
              type: 'square'
            };
          }

          return _class;
        }())();
        this.croppie = new Croppie(thumbnailFrame.get(0), croppieOptions);
      }

      this.croppie.bind({
        url: window.URL.createObjectURL(file),
        zoom: 0
      });
    }
  }, {
    key: "onEntryClick",
    value: function onEntryClick() {
      var _this2 = this;

      var size = 'viewport';
      this.croppie.result({
        type: "blob",
        size: size,
        format: 'png',
        quality: 1,
        circle: false
      }).then(function (x) {
        if (_this2.state.Modal == null || !_this2.props.userId) {
          throw Error();
        }

        var file = _this2.blobToFile(x, _this2.state.ThumbnailFileName);

        _this2.props.onEntry(_this2.props.userId, file, _this2.props.updateDateTime);

        _this2.state.Modal.modal('hide');
      });
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      var modal = $('#UserThumbnailModal');
      this.setState({
        Modal: modal
      });
      modal.modal({
        backdrop: 'static',
        keyboard: false
      }); // ポップアップが完全に非表示になった時のイベント。

      modal.on("hidden.bs.modal", function () {
        _this3.props.onHidden();
      });
      $("form").removeData("validator").removeData("unobtrusiveValidation").off("submit.validate click.validate focusin.validate focusout.validate keyup.validate invalid-form.validate");
      $.validator.unobtrusive.parse("form");
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "UserThumbnailModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("input", {
        type: "file",
        id: "Thumbnail",
        name: "Thumbnail",
        accept: "image/png,image/jpeg",
        onChange: this.onChangeThumbnail.bind(this)
      }), /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, this.state.ErrorMessages.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "validation-summary-errors alert alert-danger"
      }, /*#__PURE__*/React.createElement("ul", null, this.state.ErrorMessages.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: i
        }, x);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modalIcon"
      }, /*#__PURE__*/React.createElement("div", {
        id: "userthumbnailmodaliconframe",
        className: "thumbnailicon40frame"
      })), /*#__PURE__*/React.createElement("h3", null, intl.format(Thumbnail.Title))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-9 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group row justify-content-center"
      }, /*#__PURE__*/React.createElement("div", {
        id: "thumbnailframe",
        className: "thumbnailframe"
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-group row justify-content-center",
        style: {
          marginTop: "45px"
        }
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-form-label"
      }, this.state.ThumbnailFileName == null ? intl.format(Placeholder.Thumbnail) : this.state.ThumbnailFileName)), /*#__PURE__*/React.createElement("div", {
        className: "form-group row justify-content-center"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-form-label"
      }, intl.format(Description.InputDescriptionFileSize, {
        size: (maxFileSize / 1024 / 1024).toString() + "MB"
      }))))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.onUploadClick.bind(this),
        tabIndex: -1
      }, intl.format(Action.Upload)), this.state.isFileSelected && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-default",
        onClick: this.onEntryClick.bind(this),
        tabIndex: -1
      }, intl.format(Action.Entry))))));
    }
  }]);

  return MainComponent;
}(React.Component);

export { MainComponent as default };